import type { RouteRecordRaw } from 'vue-router'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import { GIFT_CARDS } from './routes.constants'

export default (): RouteRecordRaw[] => {
  const experiments = useExperiments()
  const { features } = useMarketplace()
  const isGiftCardsEnabled =
    experiments['experiment.giftCards'] === 'withGiftCards' &&
    features.giftCards.enabled

  return [
    {
      path: 'gift-cards',
      name: GIFT_CARDS.INDEX,
      component: () =>
        import('~/scopes/gift-cards/pages/GiftCards/GiftCards.vue'),
      meta: {
        owners: ['bot-squad-extended-services-front'],
        routeExists: isGiftCardsEnabled,
        tracking: { contentGroup: 'Gift' },
      },
    },
  ]
}
